//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotesItem from './components/NotesItem.vue';
export default {
    components: {
        NotesItem,
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            uploadLists: []
        };
    },
    mounted() {
        this.$tools.removeStorage('input');
        // console.log(this.$tools.getStorage('img_url'));
        if (this.$tools.getStorage('img_url')) {
            this.uploadLists.push({ url: this.$tools.getStorage('img_url') });
        }
    },
    methods: {
        handleDelete(file, detail) {
            this.uploadLists.splice(detail.index, 1);
            this.$tools.removeStorage('img_url');
            this.$emit('deleteFile', file);
            return true;
        },
        beforeRead(file) {
            if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
                this.$toast('请上传 jpg/jpeg/png 格式图片');
                return false;
            }
            const isLt = file.size / 1024 / 1024 < 200;
            if (!isLt) {
                this.$toast('上传文件大小不能超过 200 MB!');
                return false;
            }
            return true;
        },

        upload(formData) {
            return new Promise((resolve, reject) => {
                this.$http.post('/api/zuul/wtcp-material/uploads/material/image', formData)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 上传
        async afterRead(file) {
            // let formData = new FormData();
            // formData.append('file', file.file);
            // let result = await this.upload(file);
            // let img_Url = result.data[0].filePath;
            // this.$tools.setStorage('img_url', img_Url);


            let formData = new FormData();
            formData.append('file', file.file);
            // 此时可以自行将文件上传至服务器
            let res = await this.upload(formData);
            let data = res.data;

            if (data) {
                let img_url = this.PIC_BASE_URL + data[0].filePath;
                this.uploadLists = [];
                this.uploadLists.push({ url: img_url })
                // this.formData.pic = data[0].filePath;
                this.$tools.setStorage('img_url', img_url);
            }
        },
        handleSave() {
            // this.$router.push({
            //   name: 'myStrategy'
            // })
        },

        handleSubmit() {
            if (
                this.$tools.getStorage('gl1') &&
                this.$tools.getStorage('gl2') &&
                this.$tools.getStorage('gl3') &&
                this.$tools.getStorage('img_url') &&
                this.$tools.getStorage('zhaiyao') &&
                this.$tools.getStorage('areaa')
            ) {
                let tags = JSON.parse(this.$tools.getStorage('tag'));
                let list = [];
                let obj = {};
                if (tags) {
                    tags.forEach(item => {
                        obj = {};
                        obj.parentTag = null;
                        obj.tagCatagory = item.id.substring(1);
                        obj.tagName = item.label;
                        list.push(obj);
                    });
                }
                let strategyLists = JSON.parse(this.$tools.getStorage('glyj'));
                let list2 = [];
                let obj2 = {};
                if (strategyLists) {
                    strategyLists.forEach(item => {
                        obj2 = {};
                        obj2.link = null;
                        obj2.description = item.des;
                        obj2.sortNum = Number(item.sortNum);
                        obj2.title = item.name;
                        obj2.noteList = item.yjList;
                        list2.push(obj2);
                    });
                }
                // console.log(list2);//所在区域

                const data = {
                    author: 'admin',
                    regionName: this.$tools.getStorage('areaa').replace(/[/]/g, ','),
                    title: this.$tools.getStorage('gl1'),
                    subTitle: this.$tools.getStorage('gl2'),
                    shareTitle: this.$tools.getStorage('gl3'),
                    titleImageUrl: this.$tools.getStorage('img_url'),
                    summary: this.$tools.getStorage('zhaiyao'),
                    tipTagsListModel: { list },
                    sortNum: 0,
                    operationType: 125001001,
                    tipCatalogListModel: { list: list2 },
                    tipSelfModel: { tipSelfId: JSON.parse(localStorage.getItem('userInfo')).user.username }
                };
                console.log(data); //所在区域

                this.$dialog
                    .confirm({
                        title: '提示',
                        message: '确认发表该攻略？'
                    })
                    .then(() => {
                        // this.$publicApi.chageGl('812883768590426112',data).then(result => {
                        this.$http.post(`/api/wtcp-traveltips/tipSelf?access_token=${this.userInfo.access_token || ''}`, data)
                            .then(result => {
                                if (result.data.msg == 'success') {
                                    //  this.$tools.removeStorage('clearAll')
                                    sessionStorage.clear();
                                    this.$dialog
                                        .alert({
                                            title: '提示',
                                            message: '发表成功！'
                                        })
                                        .then(() => {
                                            this.$router.push({
                                                name: 'myStrategy'
                                            });
                                        });
                                }
                            });
                    });
            } else {
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入相关信息！'
                });
                return false;
            }
        }
    }
};
